import styled from "styled-components";


const WrapPopupExportFileV2 = styled.div`
    position: absolute;
    width: 350px;
    right: 0;
    top: 30px;
    background: #FFFFFF;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding: 20px;
    z-index: 10;


    .popup-content{
        display: flex;
        flex-direction: column;
        font-family: 'Open Sans';
        font-style: normal;
        .icon-close{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            cursor: pointer;
        }
        .content-title{
            font-family: 'Open Sans';
            font-style: normal;
            margin-bottom: 22px;
            .title{
                font-weight: 600;
                font-size: 15px;
                line-height: 20px;
                letter-spacing: -0.01em;
                color: #313131;
            }
            .value{
                font-weight: 400;
                font-size: 11px;
                line-height: 15px;
                letter-spacing: -0.02em;
                color: #313131;
            }
        }
        .content-date-time{
            height: 32px;
            display: flex;
            align-items: center;
            border-radius: 33px;
            border: 0.5px solid #B7B7B7;
            box-sizing: border-box;
            padding: 9px 14px;
            margin-bottom: 20px;
            .date-title{
                font-family: 'Open Sans';
                font-style: normal;
                font-weight: 600;
                font-size: 11px;
                line-height: 15px;
                letter-spacing: -0.02em;
                color: #313131;
                margin: 0 12px 0 6px;
            }
        }
        .content-checkbox{
            display: grid;
            gap: 12px;
            grid-template-columns: repeat(2, 170px);
            .info-check{
                gap: 6px;
            }
        }
        .content-bottom{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
            .bottom-left{
                background: none;
                font-family: 'Open Sans';
                font-style: normal;
                font-weight: 600;
                font-size: 13.5px;
                line-height: 18px;
                letter-spacing: -0.01em;
                color: #33ADFF;
                padding: 0;
            }
        }
    }
`

export {
    WrapPopupExportFileV2
}